/*
1- Important!! the svg element on the .svg file might need set ...<svg width="100%" height="100%"

2- To use this icon wrapper component you need to import a svg file as react component
E.g. import { ReactComponent as DesktopSlash } from 'static/containers/LiveSession/desktop-slash.svg';

3- then wrap it with the SvgIcon and set size/color
        <SvgIcon color="white" size="2rem">
          <DesktopSlash />
        </SvgIcon>
*/

import React from 'react';
import { ColorNames, color } from '@morressier/ts';
import styled from 'styled-components';

interface SvgIconProps {
  color: ColorNames;
  size: '0.5rem' | '1rem' | '1.5rem' | '2rem' | '2.5rem' | '3rem' | '3.5rem';
  children: React.ReactNode;
}

const StyledSvgIcon = styled.div.attrs((props: SvgIconProps) => ({
  color: props.color || 'grey',
  size: props.size,
}))`
  * {
    fill: ${props => color(props.color)};
    width: ${props => props.size};
  }
`;

export const SvgIcon = (props: SvgIconProps) => (
  <StyledSvgIcon {...props}>{props.children}</StyledSvgIcon>
);
